import {Component, Material, MeshComponent, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {BlobPrefabs} from './blob-prefabs.js';
import {RNG} from '../utils/rng.js';
import {CursorTarget} from '@wonderlandengine/components';
import {WLUtils} from '../utils/WLUtils.js';
import {RewardAwarder} from './RewardAwarder.js';

export class RewardPickerBase extends Component {
    static TypeName = 'reward-picker-base';

    @property.object({required: true})
    blobObject!: Object3D;

    @property.object({required: true})
    bevelObject!: Object3D;

    @property.object({required: true})
    leftEyeObject!: Object3D;

    @property.object({required: true})
    rightEyeObject!: Object3D;

    @property.object({required: true})
    insideObject!: Object3D;

    @property.object({required: true})
    animationObject!: Object3D;
    @property.object({required: true})
    ribbonObject!: Object3D;

    @property.material()
    ribbonGold?: Material;

    @property.material()
    ribbonSilver?: Material;

    @property.material()
    ribbonPink?: Material;

    @property.material()
    ribbonGreen?: Material;

    initialize(pieceName: string) {
        const blobPrefab = BlobPrefabs.instance.blobPrefabs.findByName(pieceName)[0];
        const bevel = blobPrefab.findByName('bevel', true)[0];
        const eye = blobPrefab.findByName('eye_right', true)[0];
        const inside = blobPrefab.findByName('Mesh.Inside', true)[0];

        this.blobObject.getComponent(MeshComponent).material =
            bevel.getComponent(MeshComponent).material;
        this.bevelObject.getComponent(MeshComponent).material =
            bevel.getComponent(MeshComponent).material;

        this.leftEyeObject.getComponent(MeshComponent).material =
            eye.getComponent(MeshComponent).material;
        this.rightEyeObject.getComponent(MeshComponent).material =
            eye.getComponent(MeshComponent).material;
        this.insideObject.getComponent(MeshComponent).material =
            inside.getComponent(MeshComponent).material;

        this.ribbonObject.getComponent(MeshComponent).material = RNG.getItem([
            this.ribbonGold,
            this.ribbonSilver,
            this.ribbonPink,
            this.ribbonGreen,
        ]);
    }
}

export class RewardPicker extends RewardPickerBase {
    static TypeName = 'reward-picker';
    static InheritProperties = true;

    @property.object({required: true})
    otherRewardPickerObjectA!: Object3D;

    @property.object({required: true})
    otherRewardPickerObjectB!: Object3D;

    @property.int(0)
    index = 0;

    onActivate(): void {
        this.object.getComponent(CursorTarget).onClick.add(this._select);
    }
    onDeactivate(): void {
        this.object.getComponent(CursorTarget).onClick.remove(this._select);
    }

    private _select = () => {
        RewardAwarder.instance.rewardChosen(this.index);
        WLUtils.setActive(this.object, false);
        WLUtils.setActive(this.otherRewardPickerObjectA, false);
        WLUtils.setActive(this.otherRewardPickerObjectB, false);
    };
}
